var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.title, returnUrl: _vm.returnUrl } },
    [_c("payment-lmsg")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }